<template>
    <div class="setting-page">
      <h1 class="title is-2">{{ $t('sidebar.settings') }}</h1>
      <div class="card mt-2">
        <div class="card-content">
          <div class="field">
            <label class="label">{{ $t('DashboardSettings.name') }}</label>
            <div class="control">
              <input class="input" type="text" v-model.trim="place.placeName">
            </div>
          </div>

          <div class="field">
            <label class="label">{{ $t('DashboardSettings.desc') }}</label>
            <p class="note">{{ $t('DashboardSettings.descNote') }}</p>
            <div class="control">
              <textarea class="textarea" v-model="place.placeDesc"></textarea>
            </div>
          </div>

          <div class="field">
            <label class="label">{{ $t('DashboardSettings.address') }}</label>
            <div class="control">
              <input class="input" type="text" v-model="place.address">
            </div>
          </div>

          <div class="field">
            <label class="label">{{ $t('DashboardSettings.phone') }}</label>
            <div class="control">
              <input class="input" type="text" v-model="place.phone">
            </div>
          </div>
        </div>
      </div>

      


        <!-- <b-collapse :open="false" class="card" aria-id="contentIdForA11y3">
          <div slot="trigger" slot-scope="props" class="card-header" role="button" aria-controls="contentIdForA11y3">
            <p class="card-header-title">{{ $t('DashboardSettings.misc') }}:</p>
            <a class="card-header-icon">
              <b-icon :icon="props.open ? 'caret-up' : 'caret-down'">
              </b-icon>
            </a>
          </div>
          <div class="card-content">
            <div class="field">
              <label class="label">{{ $t('DashboardSettings.ogDesc') }}</label>
              <div class="control">
                <input @blur="saveEditedInfo(place)" class="input" type="text" v-model="place.ogDesc">
              </div>
            </div>

            <div class="locale-changer">
                  <label class="label">{{ $t('DashboardSettings.lang') }}</label>
                  <select v-model="$i18n.locale">
                    <option v-for="(lang, i) in langs" :key="`Lang${i}`" :value="lang">{{ $t('DashboardSettings.'+lang) }}</option>
                  </select>
                </div>

            <div class="field">
              <label class="label">{{ $t('SignupFeaturesSelect.alert18') }}</label>
              <b-switch v-model="place.startModal" type="is-info" @input="saveEditedInfo(place)" true-value="true"
                false-value="false"></b-switch>
            </div>

            <div class="field">
                  <b-field :label="$t('DashboardSettings.userStyles')">
                      <b-input type="textarea" placeholder="CSS" custom-class="code-editor"
                        v-model="place.userStyles"></b-input>
                  </b-field>
                </div>

            <div v-if="place.ordering && place.ordering.active !== undefined" class="field">
              <label class="label">{{ $t('DashboardSettings.ordering') }}</label>
              <b-switch v-model="place.ordering.active" type="is-info" @input="saveEditedInfo(place)" true-value="true"
                false-value="false"></b-switch>
            </div>

            <div class="field">
              <label class="label">{{ $t('DashboardSettings.referralBlock') }}</label>
              <b-switch v-model="place.referralBlock" type="is-info" @input="saveEditedInfo(place)" true-value="true"
                false-value="false"></b-switch>
            </div>

            <p style="color:#334E6887;">build: 126</p>
          </div>
      </b-collapse> -->
    
    <div class="card">
      <div class="card-content">
        <p class="has-text-weight-semibold">{{ $t('DashboardSettings.choiceOfCurrency') }}</p>
        <b-select style="width: 130px;font-size: 18px;margin-top: 1rem;" v-model="place.currency" @change="saveInfo()">
          <option value=" ">-</option>
          <option value="₽">₽</option>
          <option value="₴">₴</option>
          <option value="$">$</option>
          <option value="€">€</option>
          <option value="₹">₹</option>
          <option value="RM">RM</option>
        </b-select>
        <!-- <b-select :placeholder="$t('Orders.deliveryType')" v-model="deliveryOption.type">
          
          <option value="pickup">{{ $t('Orders.pickup') }}</option>
          <option value="free_delivery">{{ $t('Orders.freeDelivery') }}</option>
          <option value="paid_delivery">{{ $t('Orders.paidDelivery') }}</option>
         
        </b-select> -->
      </div>
    </div>
    <button class="button is-success" @click="saveEditedInfo(place)"
            v-bind:class="{ isLoading: isLoading }">{{ $t('DashboardTable.save') }}</button>

        <h1 class="title is-2 mt-4">{{ $t('DashboardSettings.integrations') }}</h1>
      <div class="card" style="margin-top: 1rem;">
      <div class="card-content">
          <router-link to="/poster" class="button is-info" style="margin-top: 1rem;" @click="saveEditedInfo(place)"
            >{{ $t('Poster.connectPoster') }}</router-link>
      </div>
      <!-- <div class="card-content">
          <router-link to="/iiko" class="button is-info" style="margin-top: 1rem;" @click="saveEditedInfo(place)"
            >{{ $t('Iiko.connectIiko') }}</router-link>
      </div> -->
    </div>
    </div>

    
</template>


<script>
import { mapActions, mapGetters } from "vuex";
import _ from "underscore";
import { Carousel, Slide } from 'vue-carousel';
import ThemeChooser from "./themeChooser.vue";

export default {
  name: "DashboardSetting",
  components: {
    Carousel,
    Slide,
    ThemeChooser
  },
  computed: _.extend(
    {},
    mapGetters({
      place: "getPlaceInfo"
    }),
    {}
  ),
  data() {
    return {
      // config: {
      //   imagePath:
      //     " data:image/png;base64,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",
      //   filter: "color",
      //   size: 250,
      //   version: 1
      // },
      isLoading: false,
      displayPayBlock: false,
      // saveQRhref: "#qart",
      imageModal: false,
      langs: ['ru', 'en'],
      themeChoice: "",
    };
  },

  methods: _.extend({}, mapActions(["updatePlaceInfo"]), {
    saveEditedInfo: function(place) {
      this.isLoading = !this.isLoading;
      this.place.canPublish = "true";
      this.updatePlaceInfo(place).then(() => {
        this.isLoading = !this.isLoading;
      });
      this.$ma.trackEvent({category: 'event', action: 'Place info changed', properties: {context: JSON.stringify(place)}})
      this.$ma.setUserProperties({name: this.place.placeName, phone: this.place.phone, address: this.place.address})

    },
    planName: function() {
      let now = new Date();
      let lastPaymentDate = new Date(Date.parse(this.place.lastPaymentDate));
      let timeDiff = Math.abs(now.getTime() - lastPaymentDate.getTime());
      let diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
      // console.log("Last payment was " + diffDays + " days ago");
      if (diffDays && diffDays < 60) return this.$t('DashboardSettings.pro');
      else return this.$t('DashboardSettings.test');
    },

    formatDate: function(string) {
      let date = new Date(Date.parse(string));
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let dt = date.getDate();

      if (dt < 10) {
        dt = "0" + dt;
      }
      if (month < 10) {
        month = "0" + month;
      }

      return dt + "-" + month + "-" + year;
    },
    saveQR: function() {

      var dt = ""

      var opts = {
        errorCorrectionLevel: 'H',
        type: 'image/jpeg',
        rendererOpts: {
          quality: 0.3
        }
      }
      // const myCanvas = this.$refs.qartHQ.children[0];
      // var dt = myCanvas.toDataURL("image/png");
      /* Change MIME type to trick the browser to downlaod the file instead of displaying it */

      this.$refs.qr.toDataURL('text', opts, function (err, url) {
        if (err) console.log(err)
        dt = url
      })

      dt = dt.replace(/^data:image\/[^;]*/, "data:application/octet-stream");
      dt = dt.replace(
        /^data:application\/octet-stream/,
        "data:application/octet-stream;headers=Content-Disposition%3A%20attachment%3B%20filename=qr-code.png"
      );
      this.saveQRhref = dt;
      this.$ma.trackEvent({category: 'event', action: 'QR code downloaded', label : null, value : null})
    },
    // bgSelect: function(bg) {
    //   this.imageModal = !this.imageModal;
    //   this.place.background = bg;
    //   this.place.canPublish = "true";
    //   this.updatePlaceInfo(this.place);
    //   this.$ma.trackEvent({category: 'event', action: 'Menu background style changed', properties: {background: bg}})
    // },
    themeSelect: function(themeName) {
      console.log(themeName)
      this.themeChoice = themeName;
    },
    applyTheme: function() {
      this.place.background = this.themeChoice;
      this.place.canPublish = "true";
      this.updatePlaceInfo(this.place);
      this.$ma.trackEvent({category: 'event', action: 'Menu background style changed', properties: {background: this.themeChoice}})
    }
  }),

  mounted() {
    this.$title = this.$t('title') + " | " + this.$t('DashboardSettings.title')
    this.$ma.trackEvent({category: 'event', action: 'Page viewed: ' + this.$route.fullPath, label : null, value : null})
    // this.config.value = "https://savemenu.ru/" + this.place.url + "/";
  }
};
</script>